import { apiClient } from 'modules/api-client';
import { useAuth } from 'modules/auth/AuthContext';
import { BaseCard, HibooIcon, NavigationLink } from 'modules/design-system';
import { useSupportChat } from 'modules/support-chat';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { USER_UNIT } from 'utils/unit';
import { AuthBaseCardHeader } from '../../components/AuthBaseCardHeader/AuthBaseCardHeader';
import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import {
  type Credentials,
  PasswordSignInForm,
} from '../../components/PasswordSignInForm/PasswordSignInForm';
import { Subtitle } from '../index.css';

export const PasswordSignInPage = () => {
  const { actions } = useAuth();
  const navigate = useNavigate();
  const [t] = useTranslation('user');
  const [searchParams] = useSearchParams();
  const defaultEmail = searchParams.get('email') ?? '';
  const userExists = searchParams.get('userExists') === 'true';
  const source = searchParams.get('source');
  const { identifyUser: identifySupportChatUser } = useSupportChat();
  const theme = useTheme();

  const onLogin = async ({
    email,
    password,
    authenticationChallenge,
  }: Credentials) => {
    const user = await apiClient.user.login(
      email,
      password,
      authenticationChallenge,
    );
    localStorage.setItem(USER_UNIT, user.unit);
    if (user.intercomToken) {
      identifySupportChatUser({
        id: user.id,
        email: user.email,
        token: user.intercomToken,
      });
    }
    actions.login(user);
    const path = searchParams.get('r');
    navigate(path?.length ? path : '/');
  };

  return (
    <AuthLayout>
      <BaseCard>
        <AuthBaseCardHeader
          title={
            userExists
              ? t('user.login.headerUserExists')
              : t('user.login.header')
          }
        />
        {source === 'signup' && (
          <Subtitle as="p">{t('user.login.subtitleFromSignup')}</Subtitle>
        )}
        <PasswordSignInForm
          defaultEmail={defaultEmail}
          userExists={userExists}
          source={source}
          login={onLogin}
        />
      </BaseCard>
      <NavigationLink
        to="https://www.hiboo.io"
        target="_blank"
        iconLeft={<HibooIcon small color={theme.colors.text.subtle} />}
      >
        {t('whatsHiboo')}
      </NavigationLink>
    </AuthLayout>
  );
};
